import { render, staticRenderFns } from "./AtendimentoLegadoEditForm.vue?vue&type=template&id=4bb96a70"
import script from "./AtendimentoLegadoEditForm.vue?vue&type=script&lang=js"
export * from "./AtendimentoLegadoEditForm.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoLegadoEditForm.vue?vue&type=style&index=0&id=4bb96a70&prod&lang=scss"
import style1 from "./AtendimentoLegadoEditForm.vue?vue&type=style&index=1&id=4bb96a70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports